module.exports = __webpack_public_path__ + "img/solution-cockpit01-function-pic02.647432e8.png";